import React, { useCallback, useEffect, useState } from 'react';
import { Layout } from '../components/layout/Layout';
import { Hero } from '../components/home/Hero';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { Calendar, Clock, Play, ArrowRight, BookOpen, Flame, Home, ChevronLeft, ChevronRight, Users } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const featuredEvents = [{
  title: 'Sunday Worship Service',
  time: 'Sundays @ 10:00 AM',
  category: 'Weekly',
  image: 'https://cdn.magicpatterns.com/uploads/6QWpts4dzpeFa9omhmVP66/SUNDAY_WORSHIP_-_WEBSITE.jpg'
}, {
  title: 'GAP – God Answers Prayers',
  time: 'Mondays @ 8:00 PM',
  category: 'Weekly',
  image: 'https://cdn.magicpatterns.com/uploads/tk4NYadgGLQKz8CcoXdNmK/GAP_-_WEBSITE.png'
}, {
  title: 'Impact Wednesday',
  time: 'Wednesdays @ 7:00 PM',
  category: 'Weekly',
  image: 'https://cdn.magicpatterns.com/uploads/jKVQXqzASbHqHNRgp1wEeu/IMPACT_WEDNESDAY_-_WEBSITE_FULL.png'
}, {
  title: 'Morning Cry Prayer',
  time: '6:00 AM Daily',
  category: 'Daily',
  image: 'https://cdn.magicpatterns.com/uploads/w6RZLmBgZf1M9cyG9K8cYx/MORNING_CRY_-_WEBSITE.jpg'
}, {
  title: 'Prayer Line',
  time: '12:00 PM Daily',
  category: 'Daily',
  image: 'https://cdn.magicpatterns.com/uploads/cFEkVDndjpT59o4n5Zxg9g/PRAYER_LINE_-_WEBSITE.jpg'
}, {
  title: 'Communion Service',
  time: 'Every 1st Sunday',
  category: 'Monthly',
  image: 'https://cdn.magicpatterns.com/uploads/epCJJMvmRPcNahjc1gvPxT/HOLY_COMMUNION_-_WEBSITE.png'
}, {
  title: 'Let God Arise',
  time: '1st Fri & Sat Monthly',
  category: 'Monthly',
  image: 'https://cdn.magicpatterns.com/uploads/6RDrwDLyFxxLoNdtau8fLt/LET_GOD_ARISE_-_WEBSITE.png'
}];
function HomeEventsCarousel() {
  const [current, setCurrent] = useState(0);
  const total = featuredEvents.length;
  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % total);
  }, [total]);
  const prev = useCallback(() => {
    setCurrent(prev => (prev - 1 + total) % total);
  }, [total]);
  useEffect(() => {
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [next]);
  const event = featuredEvents[current];
  return <div className="relative" data-id="element-800">
      <Link to="/events" className="block group" data-id="element-801">
        <div className="relative h-48 md:h-56 rounded-xl overflow-hidden shadow-lg" data-id="element-802">
          <AnimatePresence mode="wait" data-id="element-803">
            <motion.img key={current} src={event.image} alt={event.title} initial={{
            opacity: 0,
            scale: 1.05
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 0.5
          }} className="absolute inset-0 w-full h-full object-cover" data-id="element-804" />
          </AnimatePresence>
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F44]/90 via-[#0A1F44]/30 to-transparent" data-id="element-805" />
          <div className="relative z-10 h-full flex flex-col justify-end p-6 md:p-10" data-id="element-806">
            <span className="text-[#fc0719] text-xs font-bold tracking-[0.2em] uppercase mb-1 bg-white/90 self-start px-2 py-0.5 rounded" data-id="element-807">
              Featured Event
            </span>
            <h3 className="text-white font-serif font-bold text-lg md:text-xl uppercase tracking-wide leading-tight" data-id="element-808">
              {event.title}
            </h3>
            <p className="text-white/80 font-medium tracking-wider text-sm mt-1" data-id="element-809">
              {event.time}
            </p>
          </div>
        </div>
      </Link>

      {/* Navigation */}
      <div className="flex items-center justify-between mt-4" data-id="element-810">
        <div className="flex gap-1.5" data-id="element-811">
          {featuredEvents.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`h-1.5 rounded-full transition-all duration-300 ${i === current ? 'w-6 bg-[#fc0719]' : 'w-1.5 bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to event ${i + 1}`} data-id="element-812" />)}
        </div>
        <div className="absolute bottom-6 right-6 flex gap-2 z-20" data-id="element-813">
          <button onClick={prev} className="w-8 h-8 rounded-full bg-[#0A1F44] text-white flex items-center justify-center hover:bg-[#fc0719] transition-colors" aria-label="Previous event" data-id="element-814">
            <ChevronLeft className="w-4 h-4" data-id="element-815" />
          </button>
          <button onClick={next} className="w-8 h-8 rounded-full bg-[#0A1F44] text-white flex items-center justify-center hover:bg-[#fc0719] transition-colors" aria-label="Next event" data-id="element-816">
            <ChevronRight className="w-4 h-4" data-id="element-817" />
          </button>
        </div>
      </div>
    </div>;
}
export function HomePage() {
  return <Layout data-id="element-818">
      <Hero data-id="element-819" />

      {/* SECTION 1: ABOUT US */}
      <section className="pb-0 bg-white relative overflow-hidden" data-id="element-820">
        <div className="container-custom" data-id="element-821">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-822">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="py-8 lg:py-12" data-id="element-823">
              <span className="text-[#0A1F44] text-base font-bold tracking-[0.25em] uppercase mb-3 block" data-id="element-824">
                ABOUT US
              </span>
              <h2 className="text-xl md:text-2xl lg:text-3xl font-serif font-bold text-[#0A1F44] mb-4 leading-tight" data-id="element-825">
                Raising Disciples. Building Families.
                <br data-id="element-826" />
                Changing Nations.
              </h2>
              <p className="text-[#0A1F44]/70 text-base leading-relaxed mb-8 max-w-md" data-id="element-827">
                We are devoted to the Word, the Presence of God, and the power
                of community.
              </p>
              <Link to="/about" data-id="element-828">
                <Button variant="primary" size="md" className="font-bold tracking-wider shadow-lg shadow-red-900/20" data-id="element-829">
                  LEARN MORE <ArrowRight className="w-4 h-4 ml-2" data-id="element-830" />
                </Button>
              </Link>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="relative h-[300px] md:h-[400px] lg:h-[383px]" data-id="element-831">
              <img src="https://cdn.magicpatterns.com/uploads/cgjBgTjRK6Uqd3krUdUFsK/WhatsApp_Image_2026-03-17_at_8.03.02_PM.jpg" alt="Pastor Chris & Stella" className="w-full h-full object-cover object-top" data-id="element-832" />
              {/* Soft fade edges — subtle */}
              <div className="absolute inset-0 pointer-events-none" style={{
              background: 'linear-gradient(to right, white 0%, transparent 8%, transparent 100%)'
            }} data-id="element-833" />
              <div className="absolute inset-0 pointer-events-none" style={{
              background: 'linear-gradient(to left, white 0%, transparent 8%, transparent 100%)'
            }} data-id="element-834" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* THEME OF THE YEAR SECTION */}
      <section className="bg-[#0A1F44] py-12 md:py-20 relative overflow-hidden" data-id="element-835">
        {/* Decorative background elements matching the flyer's energy */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#fc0719]/10 rounded-full blur-[120px] -mr-48 -mt-48" data-id="element-836" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-[120px] -ml-48 -mb-48" data-id="element-837" />

        <div className="container-custom relative z-10" data-id="element-838">
          <div className="max-w-5xl mx-auto" data-id="element-839">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="flex flex-col items-center" data-id="element-840">
              <div className="inline-flex items-center gap-3 mb-6" data-id="element-841">
                <div className="h-[1px] w-8 md:w-12 bg-[#fc0719]" data-id="element-842" />
                <span className="text-[#fc0719] text-sm md:text-base font-bold tracking-[0.3em] uppercase" data-id="element-843">
                  2026 Theme of the Year
                </span>
                <div className="h-[1px] w-8 md:w-12 bg-[#fc0719]" data-id="element-844" />
              </div>

              <div className="relative group w-full max-w-4xl mx-auto" data-id="element-845">
                <div className="absolute -inset-1 bg-gradient-to-r from-[#fc0719] to-[#0A1F44] rounded-2xl blur opacity-25 group-hover:opacity-40 transition duration-1000 group-hover:duration-200" data-id="element-846"></div>
                <div className="relative bg-black rounded-xl overflow-hidden shadow-2xl border border-white/10" data-id="element-847">
                  <img src="https://cdn.magicpatterns.com/uploads/xzQy1p7852SdVpkBzFbVRR/SURPASSING_GRACE_WEBSITE.png" alt="2026 Theme: Surpassing Grace" className="w-full h-auto object-cover" data-id="element-848" />
                </div>
              </div>

              <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4,
              duration: 0.8
            }} className="mt-10 text-center" data-id="element-849">
                <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4 tracking-tight uppercase" data-id="element-850">
                  Surpassing <span className="text-[#fc0719]" data-id="element-851">Grace</span>
                </h2>
                <p className="text-white/70 text-lg md:text-xl font-medium tracking-wide italic" data-id="element-852">
                  "And God is able to bless you abundantly, so that in all
                  things at all times, having all that you need, you will abound
                  in every good work." — 2 Cor. 9:8
                </p>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* SECTION 2: OUR PILLARS */}
      <section className="pt-4 pb-16 bg-white relative" data-id="element-853">
        {/* Subtle gradient background */}
        <div className="absolute inset-0 bg-gradient-to-b from-white via-[#F5F7FA]/60 to-white pointer-events-none" data-id="element-854" />

        <div className="container-custom relative z-10" data-id="element-855">
          <div className="flex items-center justify-center gap-4 md:gap-6 mb-5" data-id="element-856">
            <div className="h-[2px] w-8 sm:w-16 md:w-32 bg-gradient-to-r from-transparent to-[#fc0719] shrink-0" style={{
            clipPath: 'polygon(100% 0, 0 50%, 100% 100%)'
          }} data-id="element-857" />
            <h2 className="text-2xl sm:text-2xl md:text-4xl font-cinzel font-bold text-[#0A1F44] uppercase tracking-wide text-center whitespace-nowrap" data-id="element-858">
              OUR PILLARS
            </h2>
            <div className="h-[2px] w-8 sm:w-16 md:w-32 bg-gradient-to-l from-transparent to-[#fc0719] shrink-0" style={{
            clipPath: 'polygon(0 0, 100% 50%, 0 100%)'
          }} data-id="element-859" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-860">
            {/* Pillar 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-white p-10 py-5 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] text-center border border-gray-100 hover:-translate-y-2 transition-transform duration-300" data-id="element-861">
              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center text-[#0A1F44]" data-id="element-862">
                <BookOpen className="w-12 h-12" strokeWidth={1.5} data-id="element-863" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#0A1F44] mb-4 uppercase tracking-wide" data-id="element-864">
                THE WORD
              </h3>
              <p className="text-[#0A1F44]/70 text-lg" data-id="element-865">
                Truth that transforms.
              </p>
            </motion.div>

            {/* Pillar 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-white p-10 py-5 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] text-center border border-gray-100 hover:-translate-y-2 transition-transform duration-300 relative overflow-hidden" data-id="element-866">
              {/* Subtle red glow behind the flame */}
              <div className="absolute top-10 left-1/2 -translate-x-1/2 w-24 h-24 bg-[#fc0719]/10 blur-2xl rounded-full" data-id="element-867" />

              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center text-[#fc0719] relative z-10" data-id="element-868">
                <Flame className="w-12 h-12" strokeWidth={1.5} data-id="element-869" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#fc0719] mb-4 uppercase tracking-wide relative z-10" data-id="element-870">
                THE PRESENCE
              </h3>
              <p className="text-[#0A1F44]/70 text-lg relative z-10" data-id="element-871">
                Power that changes lives.
              </p>
            </motion.div>

            {/* Pillar 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-white p-10 py-5 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] text-center border border-gray-100 hover:-translate-y-2 transition-transform duration-300" data-id="element-872">
              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center text-[#0A1F44]" data-id="element-873">
                <Home className="w-12 h-12" strokeWidth={1.5} data-id="element-874" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#0A1F44] mb-4 uppercase tracking-wide" data-id="element-875">
                THE FAMILY
              </h3>
              <p className="text-[#0A1F44]/70 text-lg" data-id="element-876">Belong. Grow. Serve.</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* SECTION 3: SERVICE TIMES + LATEST SERMON */}
      <section className="bg-gradient-to-br from-[#0A1F44] to-[#163A70] text-white" data-id="element-877">
        <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-878">
          {/* Left Side: Service Times */}
          <div className="p-8 md:p-10 flex flex-col justify-center items-center lg:items-start lg:pl-[8%] xl:pl-[15%]" data-id="element-879">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="w-full max-w-sm" data-id="element-880">
              <h2 className="text-xl md:text-2xl font-bold mb-8 uppercase tracking-widest" data-id="element-881">
                SERVICE TIMES
              </h2>

              <div className="space-y-4 mb-8" data-id="element-882">
                <div className="flex items-center gap-4" data-id="element-883">
                  <Calendar className="w-5 h-5 text-white/70 shrink-0" data-id="element-884" />
                  <div className="flex items-center gap-4 text-base md:text-lg font-semibold tracking-wider" data-id="element-885">
                    <span data-id="element-886">SUNDAYS</span>
                    <span className="text-white/90" data-id="element-887">10:00 AM</span>
                  </div>
                </div>

                <div className="flex items-center gap-4" data-id="element-888">
                  <Calendar className="w-5 h-5 text-white/70 shrink-0" data-id="element-889" />
                  <div className="flex items-center gap-4 text-base md:text-lg font-semibold tracking-wider" data-id="element-890">
                    <span data-id="element-891">MONDAYS (GAP)</span>
                    <span className="text-white/90" data-id="element-892">8:00 PM</span>
                  </div>
                </div>

                <div className="flex items-center gap-4" data-id="element-893">
                  <Clock className="w-5 h-5 text-white/70 shrink-0" data-id="element-894" />
                  <div className="flex items-center gap-4 text-base md:text-lg font-semibold tracking-wider" data-id="element-895">
                    <span data-id="element-896">WEDNESDAYS</span>
                    <span className="text-white/90" data-id="element-897">7:00 PM</span>
                  </div>
                </div>
              </div>

              <Link to="/visit" data-id="element-898">
                <Button variant="primary" size="md" className="font-bold tracking-wider px-8 shadow-lg shadow-red-900/40" data-id="element-899">
                  PLAN YOUR VISIT
                </Button>
              </Link>
            </motion.div>
          </div>

          {/* Right Side: Latest Sermon */}
          <div className="relative min-h-[280px] lg:min-h-[320px] flex items-center overflow-hidden group" data-id="element-900">
            {/* Background Image */}
            <div className="absolute inset-0" data-id="element-901">
              <img src="https://cdn.magicpatterns.com/uploads/oXWE3PXishkDvxsiv6kwUt/ChatGPT_Image_May_11,_2026,_06_39_40_PM.png" alt="Latest Sermon" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-902" />
              <div className="absolute inset-0 bg-[#0A1F44]/60 mix-blend-multiply" data-id="element-903" />
              <div className="absolute inset-0 bg-gradient-to-r from-[#0A1F44]/80 via-[#0A1F44]/40 to-transparent" data-id="element-904" />
            </div>

            {/* Content */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="relative z-10 p-8 md:p-12 w-full flex items-center gap-8" data-id="element-905">
              <div className="flex-1" data-id="element-906">
                <h3 className="text-sm md:text-base font-bold tracking-[0.2em] uppercase mb-4 text-white/80" data-id="element-907">
                  LATEST SERMON
                </h3>
                <h2 className="text-2xl md:text-4xl font-serif font-bold text-white mb-4 leading-tight uppercase" style={{
                textShadow: '0 4px 20px rgba(0,0,0,0.5)'
              }} data-id="element-908">
                  MOTHERS DAY
                  <br data-id="element-909" />
                  CELEBRATION 1B
                </h2>
                <div className="flex items-center gap-3 text-white/60 uppercase tracking-widest text-xs font-bold" data-id="element-910">
                  <div className="h-[1px] w-6 bg-white/30" data-id="element-911" />
                  <span data-id="element-912">Latest Message</span>
                  <div className="h-[1px] w-6 bg-white/30" data-id="element-913" />
                </div>
              </div>

              <a href="https://www.youtube.com/live/36hHSo46Gww?si=qMwk06nsTg5XeleS" target="_blank" rel="noopener noreferrer" className="shrink-0" data-id="element-914">
                <div className="w-16 h-16 md:w-20 md:h-20 bg-[#fc0719] rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 shadow-[0_0_30px_rgba(252,7,25,0.5)] cursor-pointer" data-id="element-915">
                  <Play className="w-7 h-7 md:w-8 md:h-8 text-white ml-1" fill="currentColor" data-id="element-916" />
                </div>
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* SECTION 4: UPCOMING EVENTS + GIVE ONLINE */}
      <section className="bg-white" data-id="element-917">
        <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-918">
          {/* Left Side: Events Carousel */}
          <div className="p-8 md:p-10lg:pr-8 xl:pl-[8%] 2xl:pl-[15%] bg-[#F5F7FA]" data-id="element-919">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-920">
              <div className="flex items-center gap-3 mb-3" data-id="element-921">
                <h2 className="text-xl md:text-xl font-bold text-[#0A1F44] uppercase tracking-widest" data-id="element-922">
                  UPCOMING EVENTS
                </h2>
                <Link to="/events" className="text-[#fc0719] hover:text-[#d4061a] transition-colors" data-id="element-923">
                  <ArrowRight className="w-5 h-5" data-id="element-924" />
                </Link>
              </div>

              <HomeEventsCarousel data-id="element-925" />
            </motion.div>
          </div>

          {/* Right Side: Give Online */}
          <div className="relative min-h-[320px] lg:min-h-full flex items-center justify-center overflow-hidden" data-id="element-926">
            {/* Background Image */}
            <div className="absolute inset-0" data-id="element-927">
              <img src="https://images.unsplash.com/photo-1504052434569-70ad5836ab65?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Give Online" className="w-full h-full object-cover" data-id="element-928" />
              <div className="absolute inset-0 bg-[#0A1F44]/50" data-id="element-929" />
            </div>

            {/* Content */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="relative z-10 text-center p-10 w-full max-w-md" data-id="element-930">
              <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-4 uppercase tracking-widest" style={{
              textShadow: '0 4px 20px rgba(0,0,0,0.5)'
            }} data-id="element-931">
                GIVE ONLINE
              </h2>

              <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed font-medium" style={{
              textShadow: '0 2px 10px rgba(0,0,0,0.5)'
            }} data-id="element-932">
                Support the Work
                <br data-id="element-933" />
                of the Kingdom
              </p>

              <Link to="/give" data-id="element-934">
                <Button variant="primary" size="md" className="font-bold tracking-widest px-8 shadow-lg shadow-red-900/40" data-id="element-935">
                  GIVE NOW <ArrowRight className="w-5 h-5 ml-2" data-id="element-936" />
                </Button>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    </Layout>;
}